
import jsPDF              from 'jspdf';
import fmt                from '@/components/mixins/fmt.js'
import {setFmtDate1}      from '@/functions'
export default {
    mixins : [fmt],
    methods: {
    
    exportToPDF(items,total,data1,data2)
    {
      
      
      const doc      = new jsPDF('landscape')      
      let  page      = 1
      const rows     = 35
      let pages    = parseInt(items.length / rows) == items.length / rows ? parseInt(items.length / rows) : parseInt(items.length / rows) + 1
      pages++
      let row_index   = 1
      var page_index  = 1
      const init_row  = 25
      let row         = init_row
      

      
      const col1 = 5
      const col2 = 35
      const col3 = 55
      const col4 = 135
      /*const col5 = 130*/
      const col6 = 155
      const col7 = 185
      const col8 = 220
      const col9 = 250
      const col10 = 265
      const col11 = 290


      const header = (data1,data2) =>
      {
        
        const row = 20
        
        for (let page = 1; page < pages + 1; page++) {
              
          doc.setPage(page)
        
          doc.setFontSize(12)
          doc.setFont("helvetica","normal");
          doc.setTextColor(0,0,255);
          doc.text('LISTA MOVIMENTI DAL ' + setFmtDate1(data1) + ' AL ' + setFmtDate1(data2) ,  5, 10);
          doc.setTextColor(0,0,0);
          
          doc.setFont("helvetica","bold");
          doc.setFontSize(11)
          if(page < pages)
          {  
            doc.text('FORNITORE',   col1,   row)
            doc.text('SEDE',        col2,   row)
            doc.text('STAGIONE',    col3,   row)
            doc.text('TIPO',        col4 ,  row)
        
            doc.text('NUMERO',      col6 ,  row)
            doc.text('DATA',        col7 ,  row)
          
            doc.text('Q.TA',        col8 ,  row,null,null,'right')
            doc.text('IMPONIBILE',  col9 ,  row,null,null,'right')
            doc.text('IVA',         col10 , row,null,null,'right')
            doc.text('TOTALE',      col11 , row,null,null,'right')
          }
        }  
        doc.setFont("helvetica","normal");

      }

      const footer = function()
      {
        for (let page = 1; page < pages + 1; page++) {
              
        doc.setPage(page)
        doc.setFontSize(10)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  280, 205, null, null, "center");

        }  
      }
      let index = 1
      items.forEach(item=>{
               
        doc.setFontSize(8)
                        
        doc.setFont("helvetica","normal");   
        doc.text(index.toString() + ' ' +  item.supplier.substring(0,15), col1, row)
        doc.text(item.store, col2, row)
       
        doc.text(item.data.substring(0,40), col3, row)
        doc.text(item.description + ' ' + item.movementType, col4,row)
        doc.text(item.number.substring(0,12), col6,row)
        doc.text(item.date ,col7,row)
        doc.text(item.qty.toString() ,col8,row,null,null,'right')
        doc.text(this.fmt1(item.taxable) ,col9,row,null,null,'right')
        doc.text(this.fmt1(item.tax) ,col10,row,null,null,'right')
        doc.text(this.fmt1(item.total) ,col11,row,null,null,'right')
        
        if(page_index == rows && row_index < this.items.length)
        {
          page++  
          doc.addPage("a4");
         
         
          row = init_row
          row_index++
          page_index = 1
        }
        else
        {
          row = row + 5
          row_index++
          page_index++
        }
        index++
      })

      doc.setFontSize(10)
      doc.addPage("a4")
      page++
      row = 26
      doc.setFontSize(12)
      
      doc.setFont("helvetica","bold")
      
      doc.text('Q.TA',        col8 - 10 ,  row - 5,null,null,'right')
      doc.text('IMPONIBILE',  col9 - 8 ,   row - 5,null,null,'right')
      doc.text('IVA',         col10 ,      row - 5,null,null,'right')
      doc.text('TOTALE',      col11 ,      row - 5,null,null,'right')

      doc.setTextColor(34, 139, 34);
      total.forEach(item=>
      {
        doc.text(item.TotalQty.toString() ,    col8 -10 ,row,null,null,'right')
        doc.text(this.fmt1(item.TotalTaxable) ,col9  -8, row,null,null,'right')
        doc.text(this.fmt1(item.TotalTax) ,    col10, row,null,null,'right')
        doc.text(this.fmt1(item.GrandTotal) ,  col11, row,null,null,'right')  
      }
      )
      doc.setTextColor(0,0,0);
      header(data1,data2)      
      footer()
      let fileName = 'CheckList_' + Date.now().toString()      
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },
   

    }
  }
